import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { KEY_RETURN, KEY_SPACE } from 'keycode-js';
import MLIcon from '../MLIcon';
import './Accordion.css';

const AccordionTitle = ({
  className = '',
  active = false,
  onClick = () => {},
  controlsBody = '',
  iconOpen = {
    type: 'minus',
    width: '15',
    height: '15',
    fill: '#080808',
  },
  iconClosed = {
    type: 'plus',
    width: '15',
    height: '15',
    fill: '#080808',
  },
  children = '',
  ...otherProps
}) => {

  const renderIcon = (icon, defaultProps) => {
    if (React.isValidElement(icon)) {
      return icon;
    }

    const iconProps = {
      ...defaultProps,
      ...icon,
    };

    return (
      <MLIcon
        title={`icon-${iconProps.type}`}
        className="ng-ui-accordion-icon"
        {...iconProps}
      />
    );
  };

  const getIcon = (activeState) => {
    return activeState ? iconOpen : iconClosed;
  };

  const classes = classNames(
    'ng-ui-accordion-title',
    className,
  );

  const handleKeyboardEvent = (e) => {
    if (e.keyCode === KEY_RETURN || e.keyCode === KEY_SPACE) {
      onClick();
    }
  };

  return (
    <div
      className={classes}
      onClick={onClick}
      tabIndex={0}
      role="button"
      onKeyDown={handleKeyboardEvent}
      {...otherProps}
    >
      { getIcon(active) &&
        <div className="button-wrapper">
          <button tabIndex={-1} aria-expanded={active} aria-controls={controlsBody}>
            {
              renderIcon(
                getIcon(active),
                active ? {
                  type: 'minus',
                  width: '15',
                  height: '15',
                  fill: '#080808',
                } : {
                  type: 'plus',
                  width: '15',
                  height: '15',
                  fill: '#080808',
                },
              )
            }
          </button>
        </div>
      }
      <div className="content-wrapper">
        { children }
      </div>
    </div>
  );
};

AccordionTitle.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  active: PropTypes.bool,
  onClick: PropTypes.func,
  controlsBody: PropTypes.string,
  iconOpen: PropTypes.oneOfType([
    PropTypes.shape(MLIcon.propTypes),
    PropTypes.element,
  ]),
  iconClosed: PropTypes.oneOfType([
    PropTypes.shape(MLIcon.propTypes),
    PropTypes.element,
  ]),
};

AccordionTitle.displayName = 'Accordion.AccordionTitle';

export default AccordionTitle;